<template>
  <span v-if="value" :class="`bundle bundle-${color}`">
    {{ $t(`phone-number.number.state.${value}`) }}
  </span>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function() {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'direction_to_pbx_success': {
            return 'green';
          }
          case 'direction_to_pbx_pending': {
            return 'fresh';
          }
          case 'direction_to_pbx_error': {
            return 'error';
          }
          default: {
            return 'default';
          }
        }
        /* eslint-enable */
      }
    }
  };
</script>
